import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import RoleBasedGuard from 'src/auth/guard/role-based-guard';
import PatientPortalLayout from 'src/layouts/patient-portal/patient-portal-layout';
import PatientPortalCompactLayout from 'src/layouts/patient-portal/patient-compact-layout';
import PatientPortalProfileLayout from 'src/layouts/patient-portal/patient-portal-profile-layout';
import PatientPortalCompactLayoutResults from 'src/layouts/patient-portal/patient-compact-layout-results';

import { SplashScreen } from 'src/components/loading-screen';

import PatientPortalDigitalReportView from 'src/sections/public-sections/patient-portal/view/patient-portal-digital-report-view';

// ----------------------------------------------------------------------

// PAGES
const PatientPortalLoginPage = lazy(() => import('src/pages/medicore/patient/portal/login-form'));
const PatientPortalResultsRetrievePage = lazy(() =>
  import('src/pages/medicore/patient/portal/results-retrieve-page')
);
const PatientPortalAppointmentPage = lazy(() =>
  import('src/pages/medicore/patient/portal/appointment')
);

export const patientPortalRoutes = [
  {
    path: 'patient/patient-portal',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'login',
        element: (
          <PatientPortalLayout image="/assets/background/portal-patients.jpg">
            <PatientPortalLoginPage />
          </PatientPortalLayout>
        ),
      },
      {
        path: 'digital-report/:id',
        element: (
          <AuthGuard>
            <RoleBasedGuard roles={['patient']}>
              <PatientPortalProfileLayout>
                <PatientPortalDigitalReportView />
              </PatientPortalProfileLayout>
            </RoleBasedGuard>
          </AuthGuard>
        ),
      },
      {
        path: 'results',
        element: (
          <PatientPortalCompactLayoutResults>
            <PatientPortalResultsRetrievePage />
          </PatientPortalCompactLayoutResults>
        ),
      },
      {
        path: 'appointments',
        element: (
          <PatientPortalCompactLayout>
            <PatientPortalAppointmentPage />
          </PatientPortalCompactLayout>
        ),
      }, 
    ],
  },
];
